import './Writeups.css'
import { useState, useEffect, forwardRef } from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  TextField, Modal,
  makeStyles, Typography
} from '@material-ui/core';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import Axios from 'axios';
import Cookies from 'universal-cookie';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { Edit, Cancel } from '@mui/icons-material';
import { useHistory } from 'react-router';
const Alert = forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const categoryS = [
  {
    label: '',
    value: ''
  },
  {
    value: 1,
    label: 'Esteganografía'
  },
  {
    value: 2,
    label: 'Criptografía'
  },
  {
    value: 3,
    label: 'OSINT'
  },
  {
    value: 4,
    label: 'Pwn'
  },
  {
    value: 5,
    label: 'Explotación Web'
  },
  {
    value: 6,
    label: 'Fundamentos'
  },
  {
    value: 7,
    label: 'Ingeniería Inversa'
  },
  {
    value: 8,
    label: 'Programación'
  },
  {
    value: 9,
    label: 'Seguridad Móvil'
  },
  {
    value: 10,
    label: 'Misceláneo'
  },
  {
    value: 11,
    label: 'Análisis Forense'
  },

  {
    value: 12,
    label: 'Trivia'
  },

];
function Writeups() {
  const [title, setTitle] = useState([]);
  const [category, setCategory] = useState(0);
  const [link, setLink] = useState('');
  const [updateWriteup, setUpdateWriteup] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);
  const [openError, setOpenError] = useState(false);
  const [error, setErrorMessage] = useState('');
  const [success, setSuccessMessage] = useState('');
  const [record, setRecord] = useState([]);
  const [modalEdit, setModalEdit] = useState(false);
  const [modalUserID, setModalUserID] = useState(0);
  const [modalWriteupID, setModalWriteupID] = useState(0);
  const [titleEdit, setTitleEdit] = useState([]);
  const [categoryEdit, setCategoryEdit] = useState(0);
  const [linkEdit, setLinkEdit] = useState('');
  const openModalEdit = (user_id, writeup_id) => {
    setModalUserID(user_id);
    setModalWriteupID(writeup_id);
    Axios.post(`https://${process.env.REACT_APP_BASE_URL}/api/writeups/getWriteupInfo`, { user_id: user_id, writeup_id: writeup_id }, {
      headers: { 'Authorization': userToken }
    }).then(
      (response) => {
        if (response.data.noAuth) {
          cookies.remove('tokenCTF', { path: '/' });
          history.push('/login');
        }
        else {
          setTitleEdit(response.data.writeup);
          setCategoryEdit(response.data.category);
          setLinkEdit(response.data.link);
          setModalEdit(true);
        }
      })

  }
  const closeModalEdit = () => {
    setModalUserID(0);
    setModalWriteupID(0);
    setModalEdit(false);
  }
  const onUpdate = (user_id, writeup_id) => {
    Axios.put(`https://${process.env.REACT_APP_BASE_URL}/api/writeups/updateWriteup`, {
      writeup_id: writeup_id,
      title: titleEdit,
      category: categoryEdit,
      link: linkEdit
    }, {
      headers: { 'Authorization': userToken }
    }).then(res => {
      if (res.data.noAuth) {
        cookies.remove('tokenCTF', { path: '/' });
        history.push('/login');
      }
      else {
        if (res.data.messageSuccess) {
          setSuccessMessage(res.data.messageSuccess);
          setModalEdit(false);
          setOpenSuccess(true);
          setUpdateWriteup(true);

        }
        else if (res.data.messageError) {
          setErrorMessage(res.data.messageError);
          setOpenError(true);
        }
        else {
          setSuccessMessage('')
          setErrorMessage('')
          setOpenError(false);
          setOpenSuccess(false);
        }
      }
    });
  }
  const useStyles = makeStyles(theme => ({
    card: {
      width: '80%',
      marginTop: '30px',
      marginLeft: '10%',
    },
    box: {
      display: 'flex',
      marginTop: theme.spacing(3),

    },
    boxButtonEdit: {
      display: 'flex',
      marginTop: theme.spacing(3),
      backgroundColor: '#8D002E',

    },
    boxButton: {
      display: 'flex',
      marginTop: theme.spacing(3),
      justifyContent: 'flex-end',

    },
    buttonLeft: {
      position: 'flex',
      backgroundColor: 'orange',
      right: '10%'

    },
    buttonRight: {
      marginBottom: '1%',
      marginRight: '2%',
      height: '50%',
      width: '15%',
      fontSize: '0.7em',
    },
    cardPosts: {
      width: '60%',
      marginTop: '30px',
      marginLeft: '20%',
      marginBottom: '30px'
    },
    cardHead: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    buttonModified: {
      position: 'flex',
      margin: theme.spacing(1),
    }, modalEdit: {
      position: 'absolute',
      width: '70vw',
      height: '45vh',
      backgroundColor: 'white',
      border: '2px solid #000',
      boxShadow: theme.shadows[5],
      //padding: '16px 32px 24px',
      padding: theme.spacing(2, 4, 3, 4),
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      overflow: 'auto',
    },
    cardEdit: {
      position: 'relative',
      width: '100%',

    }
  }))
  const cookies = new Cookies();
  const userToken = cookies.get('tokenCTF');
  const history = useHistory();
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenError(false);
    setOpenSuccess(false);
  };
  useEffect(() => {

    Axios.get(`https://${process.env.REACT_APP_BASE_URL}/api/writeups/getWriteup`, {
      headers: { 'Authorization': userToken }
    }).then(

      (response) => {
        if (response.data.noAuth) {
          cookies.remove('tokenCTF', { path: '/' });
          history.push('/login');
        }
        else {
          if (response.data.messageError) {
            
            setRecord([{ username: 'admin', writeup: 'No hay writeups', link: '#', category: 1, owner: true }]);
          }
          else {
            setRecord(response.data);
            setUpdateWriteup(false);

          }
        }
      })

  }, [updateWriteup])
  const onSubmit = () => {
    Axios.post(`https://${process.env.REACT_APP_BASE_URL}/api/writeups/postWriteup`, {
      title: title,
      category: category,
      link: link,
    }, {
      headers: { 'Authorization': userToken }
    }).then((res) => {
      if (res.data.noAuth) {
        cookies.remove('tokenCTF', { path: '/' });
        history.push('/login');
      }
      else {
        if (res.data.messageSuccess) {
          setTitle('');
          setCategory(0);
          setLink('');
          setSuccessMessage(res.data.messageSuccess);
          setOpenSuccess(true);
          setUpdateWriteup(true);
        }
        else if (res.data.messageError) {
          setErrorMessage(res.data.messageError);
          setOpenError(true);
        }
        else {
          setErrorMessage('');
          setOpenError(false);
          setSuccessMessage('');
          setOpenSuccess(false);
        }
      }
    });
  };
  const onDelete = (id) => {
    Axios.delete(`https://${process.env.REACT_APP_BASE_URL}/api/writeups/deleteWriteup/${id}`, {
      headers: { 'Authorization': userToken }
    }).then((res) => {
      if (res.data.noAuth) {
        cookies.remove('tokenCTF', { path: '/' });
        history.push('/login');
      }
      else {
        if (res.data.messageSuccess) {

          setSuccessMessage(res.data.messageSuccess);
          setOpenSuccess(true);
          setUpdateWriteup(true);
        }
        else if (res.data.messageError) {
          setErrorMessage(res.data.messageError);
          setOpenError(true);
        }
        else {
          setErrorMessage('');
          setOpenError(false);
          setSuccessMessage('');
          setOpenSuccess(false);
        }
      }
    });

  }
  const styles = useStyles();
  return (
    <div className="writeupsScreen">
      <div className="cardWriteUp">

        <form
          autoComplete="off"
        >
          <Card className="cardWriteUp">
            <CardHeader
              title="Crear Writeup"
            />
            <Divider />


            <CardContent>
              <Grid
                container
                spacing={3}
              >
                <Grid
                  item
                  md={6}
                  xs={12}
                >

                  <TextField
                    fullWidth
                    label="Título"
                    name="Titulo"
                    value={title}
                    variant="outlined"
                    onChange={(e) => {
                      setTitle(e.target.value)
                    }}

                  />
                </Grid>
                <Grid
                  item
                  md={6}
                  xs={12}
                >
                  <TextField
                    fullWidth
                    label="Categoría"
                    name="Category"
                    required
                    select
                    SelectProps={{ native: true }}
                    value={category}
                    variant="outlined"
                    onChange={(e) => {
                      setCategory(e.target.value)
                    }}
                  >
                    {categoryS.map((option, index) => (
                      <option
                        key={index}
                        value={option.value}
                      >
                        {option.label}
                      </option>
                    ))}
                  </TextField>
                </Grid>
                <Grid
                  item
                  md={6}
                  xs={12}
                >
                  <TextField
                    fullWidth
                    label="Link - ej. https://www.google.com"
                    name="Link"
                    value={link}

                    variant="outlined"
                    onChange={(e) => {
                      setLink(e.target.value)
                    }}
                  />
                </Grid>


              </Grid>
            </CardContent>



            <Divider />
            <Box

              className="boxButton"
            >
              <Button className="buttonRight"
                onClick={onSubmit}
                variant="contained"
                color="primary"
              >
                Publicar
              </Button>

            </Box>

          </Card>

        </form>

      </div>
      <br></br>
      {record.map((val,key) => {
        return (
          <div key={key}>
            <Card className="cardPosts" >
              <CardContent>
                <Box
                  className="boxStyling"
                >
                  <div className="cardHead">
                    <AccountCircleIcon fontSize='large' />
                    {val.username}
                  </div>
                  <Typography
                    color="textPrimary"
                    gutterBottom
                    variant="h4"
                  >
                    {val.writeup}

                  </Typography>
                  <Typography
                    color="textPrimary"
                    gutterBottom
                    variant="h6"
                  >
                    Categoría: {val.category}
                  </Typography>
                  <Typography
                    color="textPrimary"
                    gutterBottom
                  >
                    <a href={val.link}>{val.link}</a>
                  </Typography>
                  <Typography
                    color="textPrimary"
                    gutterBottom
                  >
                    <a >{val.created}</a>
                  </Typography>
                </Box>
                <Button
                  onClick={(e) => { openModalEdit(val.user_id, val.writeup_id) }}
                  variant="contained"
                  color="primary"
                  className={ val.owner ? "" : "displayNone"}
                >
                  <Edit />
                </Button>
                <Button 
                  className={ val.owner ? "buttonModified" : "buttonModified displayNone"}
                  onClick={(e) => {
                    onDelete(val.writeup_id)
                  }}
                  variant="contained"
                  color="secondary"
                >
                  <Cancel />

                </Button>
              </CardContent>
              <Divider />
            </Card>

          </div>
        );
      })}
      <Modal open={modalEdit} onClose={closeModalEdit}  >
        <div className="modalEdit">
          <Card className="cardEdit">
            <CardHeader
              title="Editar Writeup"
            />
            <Divider />
            <CardContent>
              <Grid
                container
                spacing={3}
              >
                <Grid
                  item
                  md={6}
                  xs={12}
                >

                  <TextField
                    fullWidth
                    label="Título"
                    name="Titulo"
                    value={titleEdit}
                    variant="outlined"
                    onChange={(e) => {
                      setTitleEdit(e.target.value)
                    }}

                  />
                </Grid>
                <Grid
                  item
                  md={6}
                  xs={12}
                >
                  <TextField
                    fullWidth
                    label="Categoría"
                    name="Category"
                    required
                    select
                    SelectProps={{ native: true }}
                    value={categoryEdit}
                    variant="outlined"
                    onChange={(e) => {
                      setCategoryEdit(e.target.value)
                    }}
                  >
                    {categoryS.map((option, index) => (
                      <option
                        key={index}
                        value={option.value}
                      >
                        {option.label}
                      </option>
                    ))}
                  </TextField>
                </Grid>
                <Grid
                  item
                  md={6}
                  xs={12}
                >
                  <TextField
                    fullWidth
                    label="Link"
                    name="Link"
                    value={linkEdit}

                    variant="outlined"
                    onChange={(e) => {
                      setLinkEdit(e.target.value)
                    }}
                  />
                </Grid>


              </Grid>
            </CardContent>



            <Divider />
            <Box

              className="boxButton"
            >
              <Button className="buttonRight"
                onClick={(e) => { onUpdate(modalUserID, modalWriteupID) }}
                variant="contained"
                color="primary"
              >
                Actualizar
              </Button>

            </Box>

          </Card>
        </div>
      </Modal>
      <Snackbar open={openError} autoHideDuration={3000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="error" className="alertStyling">
          {error}
        </Alert>
      </Snackbar>
      <Snackbar open={openSuccess} autoHideDuration={3000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="success" className="alertStyling">
          {success}
        </Alert>
      </Snackbar>
    </div>
  );
}

export default Writeups;